module.exports = __webpack_public_path__ + "img/3_of_Clubs.svg.86c1b4fd.png";